import { axiosGet, axiosPost } from '../ServiceBase.js';

/**
 * Turno Previo (ticket #25, ver PLAN_TURNERO_PREVIO.md): el afiliado agenda
 * un turno con anticipacion y hace check-in en la Terminal el dia de la
 * cita. La categoria de tramite NO se pide aca: se elige recien en la
 * Terminal al hacer check-in.
 */

/**
 * Sedes con turnero habilitado, para elegir donde agendar.
 * @returns {Promise<Array<{idAgencia:number, descripcion:string, localidad:string, direccion:string}>>}
 */
export const buscarAgenciasHabilitadas = async () => {
  return axiosGet('/v1/turnos/agencias-habilitadas');
};

/**
 * Slots disponibles de una agencia para un dia puntual.
 * @param {number} idAgencia
 * @param {string} fecha formato YYYY-MM-DD
 * @returns {Promise<Array<{fechaHoraInicio:string, cupoDisponible:number}>>}
 */
export const buscarFranjasDisponibles = async (idAgencia, fecha) => {
  return axiosGet(`/v1/turnos/franjas-disponibles?idAgencia=${idAgencia}&fecha=${fecha}`);
};

/**
 * Agenda el turno previo.
 * @param {{idAgencia:number, fechaHoraAgendada:string, idAfiliado?:number}} datos
 */
export const agendarTurno = async (datos) => {
  return axiosPost('/v1/turnos/agendar', datos);
};

/**
 * Turnos previos (AGENDADO, sin check-in todavia) del titular logueado y su
 * grupo familiar. Cada uno trae afiliadoNombre para distinguir a quien
 * corresponde (un titular puede tener reservas de toda su familia).
 * @returns {Promise<Array<{idTurno:number, idAgencia:number, agenciaDescripcion:string, fechaHoraAgendada:string, afiliadoNombre:string}>>}
 */
export const misTurnosAgendados = async () => {
  return axiosGet('/v1/turnos/mis-agendados');
};

/**
 * Cancela un turno previo propio o de un familiar. Solo funciona mientras
 * siga AGENDADO (sin check-in en la Terminal).
 * @param {number} idTurno
 */
export const cancelarTurno = async (idTurno) => {
  return axiosPost(`/v1/turnos/${idTurno}/cancelar-agendado`);
};
